<template>
  <section class="hero" :style="heroBgStyle">
    <div class="hero-content">
      <img src="/autogri_logo.jpg" alt="AUTOGRI Logo" class="hero-logo" />
      <h1>{{ $t('hero.title') }}</h1>
      <p>{{ $t('hero.subtitle') }}</p>
      <button class="get-in-touch-btn" @click="scrollToContact">
        {{ $t('hero.getInTouch') }}
        <svg xmlns="http://www.w3.org/2000/svg" class="arrow-icon" viewBox="0 0 20 20" fill="currentColor">
          <path fill-rule="evenodd" d="M10.293 3.293a1 1 0 011.414 0l6 6a1 1 0 010 1.414l-6 6a1 1 0 01-1.414-1.414L14.586 11H3a1 1 0 110-2h11.586l-4.293-4.293a1 1 0 010-1.414z" clip-rule="evenodd" />
        </svg>
      </button>
    </div>
  </section>
</template>

<script setup>
const heroBgStyle = {
  background: `url('/map3.png') center center/cover no-repeat`
}

const scrollToContact = () => {
  const contactSection = document.querySelector('.contact-section')
  if (contactSection) {
    contactSection.scrollIntoView({ behavior: 'smooth' })
  }
}
</script>

<style scoped>
.hero {
  height: 120vh;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  padding: 0 2rem;
  margin-top: -80px; /* Compensate for fixed navbar */
  position: relative;
  background-color: #111; /* fallback color */
  transition: background-image 0.6s cubic-bezier(.4,0,.2,1);
}

.hero::after {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(45deg, rgba(0,0,0,0.88) 0%, rgba(0,0,0,0.7) 100%);
  z-index: 1;
}

.hero-content {
  max-width: 800px;
  color: white;
  position: relative;
  z-index: 2;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 0 1rem;
}

.hero-logo {
  width: 240px;
  max-width: 80vw;
  margin-bottom: 2rem;
  border-radius: 50%;
  box-shadow: 0 4px 24px rgba(0,0,0,0.25);
  background: white;
  transition: transform 0.3s ease;
}

.hero-logo:hover {
  transform: scale(1.05);
}

.hero-content h1 {
  font-size: 3.5rem;
  margin-bottom: 1.5rem;
  line-height: 1.2;
  color: #ffffff;
  text-shadow: 2px 2px 8px rgba(0, 0, 0, 0.5);
  font-weight: 700;
}

.hero-content p {
  font-size: 1.5rem;
  opacity: 0.95;
  line-height: 1.5;
  color: #e0e0e0;
  text-shadow: 1px 1px 6px rgba(0,0,0,0.4);
  max-width: 600px;
}

.get-in-touch-btn {
  margin-top: 2rem;
  padding: 1rem 2rem;
  font-size: 1.1rem;
  font-weight: 600;
  color: white;
  background: linear-gradient(45deg, #333 0%, #222 100%);
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 8px;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 0.75rem;
  transition: all 0.3s ease;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.2);
}

.get-in-touch-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.3);
  background: linear-gradient(45deg, #404040 0%, #2a2a2a 100%);
}

.get-in-touch-btn:active {
  transform: translateY(0);
}

.arrow-icon {
  width: 20px;
  height: 20px;
  transition: transform 0.3s ease;
}

.get-in-touch-btn:hover .arrow-icon {
  transform: translateX(4px);
}

@media (max-width: 768px) {
  .hero {
    height: 120vh;
    padding: 0 1rem;
  }

  .hero-content {
    padding: 0;
  }

  .hero-content h1 {
    font-size: 2rem;
    margin-bottom: 1rem;
  }

  .hero-logo {
    width: 140px;
    margin-bottom: 1.5rem;
  }

  .hero-content p {
    font-size: 1.1rem;
    padding: 0 0.5rem;
  }

  .get-in-touch-btn {
    padding: 0.875rem 1.75rem;
    font-size: 1rem;
  }
}

@media (max-width: 480px) {
  .hero-content h1 {
    font-size: 1.75rem;
  }

  .hero-content p {
    font-size: 1rem;
  }

  .hero-logo {
    width: 120px;
  }

  .get-in-touch-btn {
    padding: 0.75rem 1.5rem;
    font-size: 0.95rem;
  }
}
</style> 